import { createApiAction } from '@app/packages/api/utils'
import type { ApiLink } from '@app/packages/api/v2/types/entities'

export const getLinks = () => createApiAction('getLinks', dispatch => dispatch<{ data: ApiLink[] }>({ method: 'GET', endpoint: '/api/v2/links' }))
